// extracted by mini-css-extract-plugin
export default {"wrapper":"Guides_wrapper__fGOfi","title":"Guides_title__P5msx","iFrame":"Guides_iFrame__UVovD"};